"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _ = require("../..");

var _mobxReact = require("mobx-react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

require("./Toast.css");

var _styles = {
  "container": "Toast__container___3NqLp",
  "animate": "Toast__animate___2Eu5t",
  "success": "Toast__success___1Qwwg",
  "error": "Toast__error___2Es3-",
  "warning": "Toast__warning___10qtI",
  "location": "Toast__location___3S1FM"
};

const styles = _bind.default.bind(_styles);

const Toast = (0, _mobxReact.observer)(({
  className,
  dataTestId,
  toasts,
  setToast,
  onToastDisappear
}) => {
  const composed_classname = (0, _bind.default)(styles('location'), className);
  const toastContainerRef = (0, _react.useRef)();

  const renderToast = (item, i) => {
    const toast_classname = styles('container', item === null || item === void 0 ? void 0 : item.status);

    const ToastIcon = () => {
      switch (item === null || item === void 0 ? void 0 : item.status) {
        case 'success':
          return _react.default.createElement(_.FontAwesome, {
            name: 'circle-check',
            size: 15,
            color: _.Color.green._70
          });

        case 'error':
          return _react.default.createElement(_.FontAwesome, {
            name: 'triangle-exclamation',
            size: 15,
            color: _.Color.pink._70
          });

        case 'warning':
          return _react.default.createElement(_.FontAwesome, {
            name: 'triangle-exclamation',
            size: 15,
            color: _.Color.semantic.$warning500
          });

        default:
          return _react.default.createElement(_.FontAwesome, {
            name: 'info-circle',
            size: 15,
            color: _.Color.neutral._90
          });
      }
    };

    return _react.default.createElement("div", {
      key: i,
      "data-testid": dataTestId,
      className: toast_classname
    }, _react.default.createElement(ToastIcon, null), _react.default.createElement(_.Text, {
      text: item === null || item === void 0 ? void 0 : item.text
    }));
  };

  (0, _react.useEffect)(() => {
    if (toasts.length > 0) {
      let timer = setTimeout(() => {
        setToast([]);
        timer = null;
      }, 4000);
      return () => {
        if (timer) {
          clearTimeout(timer);
          timer = null;
          if (onToastDisappear) onToastDisappear();
        }
      };
    }
  }, [toasts]);
  return _react.default.createElement("div", {
    className: composed_classname,
    ref: toastContainerRef
  }, toasts.slice(0, 3).map((item, i) => renderToast(item, i)));
});
var _default = Toast;
exports.default = _default;